import {formatter, request} from '@/utils/request';

export namespace BankAccount {
  export const Path = {
    Search: '/expenseapi/bankAccount/search',
    Get: '/expenseapi/bankAccount/get',
    AjaxSearch: '/expenseapi/bankAccount/ajaxSearch',

  };


  export async function search(body: API.BankAccountFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.BankAccount[]>>(Path.Search, formatter(options));
  }

  export async function ajaxSearch(body: API.BankAccountFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.BankAccount[]>>(Path.AjaxSearch, formatter(options));
  }

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.BankAccount>>(Path.Get, formatter(options));
  }
}
